import { Pipe } from '@angular/core';

import { UgcLinksContentService } from '../../services';

@Pipe({ name: 'ugcLinksHighlight' })
export class UgcLinksHighlightPipe {
  constructor(private ugcLinksContentService: UgcLinksContentService) {}

  transform(value: any, options?: any): string {
    return this.ugcLinksContentService.highlightLinks(value);
  }
}
